module.exports = __webpack_public_path__ + "img/synthesisScore_bg.6e873a09.jpg";